import { GridCellProps } from '@progress/kendo-react-grid';
import { DetailArrowIcon } from 'app/assets/icons';
import { AdminProfileInfo } from 'app/components/AdminProfileInfo';
import styled from 'styled-components';

type Props = {
  className?: string;
  e: GridCellProps;
  onViewClick?: (e) => void;
};

const UserProfileCell = ({ className, e, onViewClick }: Props) => {
  const data = e?.dataItem;
  return (
    <StyledTd
      style={e.style}
      className={e.className}
      onClick={() => onViewClick?.(data)}
    >
      <CustomTableColumnWrapper>
        <AdminProfileInfo src={data?.imageUrl ?? ''} name={data?.name} />
        <div>
          <DetailArrowIcon />
        </div>
      </CustomTableColumnWrapper>
    </StyledTd>
  );
};

export default UserProfileCell;
const StyledTd = styled.td``;
const CustomTableColumnWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px 0 0px;
`;
